export default class Consts {
    static drawerWidth = 250;
    static containerSX = { maxWidth: '1100px', minWidth: '450px', width: '75%' }
}